import React, {Component} from 'react'
import {Badge, Container, Form, Row, Table} from 'react-bootstrap';
import './CCartEntry.css';
import {MdDelete} from 'react-icons/md';
import ApiV0 from '../services/ApiV0'
import CUtils from '../services/CUtils';
import CPrice from '../_common/CPrice';
import CListingCustomizationValue from './CListingCustomizationValue';
import {withTranslation} from 'react-i18next';

import {decode} from 'html-entities';

class CCartEntry extends Component {
    constructor(props) {
        super(props);
        this.wrapper = React.createRef();
    }

    state = { loaded: false };

    onClick(productLink) {
        document.location = productLink;
    }

    decodedTitle() {
        const lang = ApiV0.getLang();
        const label = lang === 'en' && this.props.product.en_label ? this.props.product.en_label : this.props.product.label;
        return decode(label);
    }

    getTitle(limit = 100) {
        return CUtils.generateShortTitle(this.decodedTitle(), limit);
    }

    generateImageUrl() {
        return this.props.product["url_570xN"] || null;
        // return this.props.product.images[0]["url_170x135"];
    }
    removeFromCart() {
        const {t, product, onCartUpdated, onCartError} = this.props;
        const title = this.getTitle();
        const quantityToSet = 0;
        ApiV0.addToCart(product.listing_id, quantityToSet, product.variation_key, product.variation_value,
            product.customization_value)
            .then(cart => onCartUpdated(`1 ${title} ${t('cart.entry.removed')}`))
                .catch(error => onCartError(`1 ${title} ${t('cart.entry.cantBeRemoved')}`));
    }

    changeWantedQuantity(event) {
        const {t, product, onCartUpdated, onCartError} = this.props;
        const title = this.getTitle();
        const wantedQuantity = event.target.value;
        console.info("changeWantedQuantity", wantedQuantity);
        ApiV0.addToCart(product.listing_id, wantedQuantity, product.variation_key, product.variation_value)
            .then(cart => onCartUpdated(`${wantedQuantity} ${title} ${t('cart.entry.inCart')}`))
            .catch(error => onCartError(`${wantedQuantity} ${title} ${t('cart.entry.impossible')} : ${error}`));
    }

    render() {
        const {t, product} = this.props;
        const lang = ApiV0.getLang();
        const listingId = product.listing_id;
        const hasVariations = product.variation_key && product.variation_value;
        const hasCustomization = product.customization_value;
        const variationValue = lang === 'en' && product.en_variation_value ? product.en_variation_value : product.variation_value;
        const currency = product.unit_price_code === 'EUR' ? "€" : product.unit_price_code;
        const quantity = product ? product.quantity : 0;
        const quantityMax = product ? product.quantityMax : 0;
        const quantityToSet = this.state.wantedQuantity ? this.state.wantedQuantity : Math.min(quantity, quantityMax);
        const isModeCart = this.props.mode === 'cart';
        const title = this.getTitle();
        const productLink = CUtils.generateProductLink(this.props.product.shop_section_id, this.props.product.listing_id, this.decodedTitle())

        const imageUrl = this.generateImageUrl();
        const hasImage = imageUrl !== null;
        const entryImage = hasImage ? <img className="widthImage" alt="product"
                                           src={imageUrl} onLoad={() => this.setState({loaded: true})}/> : null;

        const entryDetails = (<>
            {/* product.quantity > 1 ? (
              <span>Quantité: <span className="cproductQuantity">{product.quantity}</span><br/></span>
            ) :null */}

            <Table border="0" size="sm">
                <tbody>

                <tr>
                    <td colSpan="2" className="productTitle"><a href={productLink}><span
                        itemProp="name">{title}</span></a>&#160;
                        {hasVariations ? (<Badge bg="light"
                                                 className="chBadge cartBadge">{/*product.variation_key: */}{variationValue}</Badge>) : null}
                    </td>
                </tr>
                {hasCustomization ? (
                    <tr>
                        <td colSpan="2"><CListingCustomizationValue value={product.customization_value}/>
                        </td>
                    </tr>
                ) : null}
                <tr>
                    <td className="cartproductPriceLabel">{t('cart.entry.unitPrice')}:</td>
                    <td><CPrice price={product.unit_price_raw}
                                oldPrice={product.unit_price_base}
                                currency={currency}/></td>
                </tr>
                {isModeCart && quantity > quantityMax ? (
                    <tr>
                        <td colSpan="2"><i>{t('cart.entry.quantityStock', {quantity, quantityMax})}</i></td>
                    </tr>
                ) : null}
                {isModeCart && !hasCustomization && product.quantityMax > 1 ? (
                    <tr>
                        <td>{t('cart.entry.quantity')} :</td>
                        <td>
                            <Form.Select value={quantityToSet}
                                         onChange={this.changeWantedQuantity.bind(this)}
                                         style={{width: 70}}>
                                {[...Array(product.quantityMax).keys()].map((val, index) => {
                                    return (
                                        <option key={index} index={index} value={val + 1}>{val + 1}</option>)
                                })}
                            </Form.Select>
                        </td>
                    </tr>
                ) : null}
                {quantity > 1 && (hasCustomization || (!isModeCart && quantityMax > 1)) ? (
                    <tr>
                        <td>{t('cart.entry.quantity')} :</td>
                        <td>{quantityToSet}</td>
                    </tr>
                ) : null}

                {isModeCart ? (
                    <tr>
                        <td>&#160;</td>
                        <td>
                            <button className="btn-delete"
                                    onClick={this.removeFromCart.bind(this)}
                                    title={t('cart.entry.doRemoveFromCart')}>
                                <MdDelete/>{t('cart.entry.doRemoveFromCart')}
                            </button>
                        </td>
                    </tr>
                ) : null}
                </tbody>
            </Table>
        </>);

        return (

            <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" name={title}
                 key={this.props.index}
                 id={`card-${listingId}`}>
                <meta itemProp="position" content={this.props.index}/>
                <meta itemProp="url" content={productLink}/>
                <Container className="largeScreen">
                    <Row>
                        <table>
                            <tbody>
                            <tr>
                                <td className="widthImageCell">
                                    {hasImage ? <div onClick={this.onClick.bind(this, productLink)}>{entryImage}</div> : <>&#160;</>}
                                </td>
                                <td>
                                    {entryDetails}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </Row>
                </Container>
                <Container className="smallScreen">
                    {entryImage}<br/>
                    {entryDetails}
                </Container>
            </div>

        );

    }
}

export default withTranslation('common')(CCartEntry);